<template>
    <div class="sme-success">
        <div class="_ml-56-0 _w-592">
            <h2 class="h2" v-html="title"></h2>
            <p class="p1 _mt-16-8" v-html="subtitle"></p>
        </div>
        <img class="_w-488 _ml-81 _mobile-hidden" :src="setImg(type)" />
    </div>
</template>
<script>
export default {
    name: 'SmeFormMessage',
    props: {
        title: String,
        subtitle: String,
        type: {
            type: String,
            default: 'sent',
        },
        imgSent: {
            type: String,
            default: '',
        },
        imgDouble: {
            type: String,
            default: '',
        },
        imgError: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            imgSentDefault: '/local/templates/redesign/src/assets/img/sme/success.webp',
            imgErrorDefault: '/local/templates/redesign/src/assets/img/sme/error.webp',
        }
    },
    methods: {
        setImg(type) {
            let imgUrl;
            switch(type) {
                case 'sent': imgUrl = this.imgSent ? this.imgSent : this.imgSentDefault; break;
                case 'error': imgUrl = this.imgError ? this.imgError : this.imgErrorDefault; break;
            }
            return imgUrl;
        }
    }
};
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/base/_variables.scss';
    @import '../../assets/scss/base/_mixins.scss';
    @import '../../assets/scss/base/_functions.scss';

    $b: '.sme-success';

    #{$b} {
        display: flex;
        align-items: center;
        background-color: $grey-106;
        @include fluid('height', 440px);
        @include fluid('border-radius', 56px, 24px);

        @include mobile {
            height: auto;
            @include fluid('padding-top', 24px);
            @include fluid('padding-right', 16px);
            @include fluid('padding-bottom', 24px);
            @include fluid('padding-left', 16px);
        }
    }
</style>
